import { entries, keys } from "remeda";
// src/i18n/effects.ts
const getLocaleIdFromModulePath = (modulePath) => modulePath.slice(modulePath.lastIndexOf("/") + 1, -3);
/**
* Builds a locale loader over a lazy catalog produced by `import.meta.glob`.
*/
const createLocaleLoader = (moduleCatalog) => {
	const moduleLoaders = new Map(entries(moduleCatalog).map(([modulePath, moduleLoader]) => [getLocaleIdFromModulePath(modulePath), moduleLoader]));
	return async function loadLocale(locale) {
		const moduleLoader = moduleLoaders.get(locale);
		if (!moduleLoader) throw new Error(`Locale module not found for ${locale}`);
		const { messages } = await moduleLoader();
		console.info(`[i18n] Loaded locale ${locale} with ${keys(messages).length} messages`);
		return messages;
	};
};
const combineLocaleLoaders = (...localeLoaders) => async (locale) => Object.assign({}, ...await Promise.all(localeLoaders.map((loadLocale) => loadLocale(locale))));
export { combineLocaleLoaders, createLocaleLoader };

//# sourceMappingURL=effects.js.map